import React, { useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import FCMCreateForm from './FCMCreateForm'
import FCMDataTable from './FCMDataTable'
import FCMLoading from './FCMLoading'
import FCMPreview from './FCMPreview'
import { useFirebaseCloudMessagingList } from './hooks/useFirebaseCloudMessagingList'
import { updateFirebaseCloudMessaging } from './services'
import { NOTIFICATION_STATUSES } from './constants'
import clsx from 'clsx'

export default function FCM() {
  const [isLoading, setIsLoading] = useState(false)
  const [isShowPreview, setIsShowPreview] = useState(false)
  const [isShowCreateForm, setIsShowCreateForm] = useState(false)
  const [notification, setNotification] = useState(null)
  const [filter, setFilter] = useState('UNKNOWN')
  const [currentPage, setCurrentPage] = useState(1)

  const { firebaseCloudMessagingList, refetch, data } = useFirebaseCloudMessagingList({
    status: filter,
    pageParam: currentPage,
  })

  const pagination = data?.pagination

  const alertCatchMessage = (err) => {
    alert(err?.reason?.message ?? err.message)
  }

  const handleClickFilter = (filter) => {
    setCurrentPage(1)
    setFilter(filter)
  }

  const handleClickNextPage = () => {
    setCurrentPage((current) => current + 1)
  }

  const handleClickPrevPage = () => {
    setCurrentPage((current) => current - 1)
  }

  const handleDeleteNotification = (id) => {
    updateFirebaseCloudMessaging({ id })
      .then((res) => {
        alert('ทำการลบเรียบร้อยค่ะ')
        refetch()
      })
      .catch((err) => {
        alertCatchMessage(err)
      })
  }

  const handleNotificationSelected = (notification) => {
    setNotification(notification)
    setIsShowPreview(true)
  }

  const handleCloseCreateForm = () => {
    setIsShowCreateForm(false)
    if (currentPage > 1) {
      setCurrentPage(1)
    } else {
      refetch()
    }
  }

  const handleClosePreview = () => {
    setIsShowPreview(false)
  }

  return (
    <>
      <FCMCreateForm
        isShow={isShowCreateForm}
        onHide={handleCloseCreateForm}
        onCancel={handleCloseCreateForm}
        onSend={handleCloseCreateForm}
      />
      <FCMPreview notification={notification} isShow={isShowPreview} onHide={handleClosePreview} />
      <Card>
        <Card.Header>
          <Card.Title>Firebase Cloud Message</Card.Title>
          {!isLoading && (
            <button className="btn btn-primary" onClick={() => setIsShowCreateForm(true)}>
              สร้าง การแจ้งเตือน
            </button>
          )}
        </Card.Header>
        <Card.Body>
          <Row>
            <Col>
              <div className="d-flex">
                <button className="btn" disabled>
                  กรอง
                </button>
                <button
                  className={clsx('btn ml-2', {
                    'btn-primary': filter === NOTIFICATION_STATUSES.UNKNOWN,
                  })}
                  onClick={() => handleClickFilter(NOTIFICATION_STATUSES.UNKNOWN)}
                >
                  ทั้งหมด
                </button>
                <button
                  className={clsx('btn ml-2', {
                    'btn-primary': filter === NOTIFICATION_STATUSES.PUBLISH,
                  })}
                  onClick={() => handleClickFilter(NOTIFICATION_STATUSES.PUBLISH)}
                >
                  เผยแพร่แล้ว
                </button>
                <button
                  className={clsx('btn ml-2', {
                    'btn-primary': filter === NOTIFICATION_STATUSES.IN_PROGRESS,
                  })}
                  onClick={() => handleClickFilter(NOTIFICATION_STATUSES.IN_PROGRESS)}
                >
                  กำลังดำเนินการ
                </button>
                <button
                  className={clsx('btn ml-2', {
                    'btn-primary': filter === NOTIFICATION_STATUSES.DRAFT,
                  })}
                  onClick={() => handleClickFilter(NOTIFICATION_STATUSES.DRAFT)}
                >
                  ยังไม่ได้เผยแพร่
                </button>
                <button
                  className={clsx('btn ml-2', {
                    'btn-primary': filter === NOTIFICATION_STATUSES.CANCEL,
                  })}
                  onClick={() => handleClickFilter(NOTIFICATION_STATUSES.CANCEL)}
                >
                  ยกเลิก
                </button>
                <button
                  className={clsx('btn ml-2', {
                    'btn-primary': filter === NOTIFICATION_STATUSES.FAILED,
                  })}
                  onClick={() => handleClickFilter(NOTIFICATION_STATUSES.FAILED)}
                >
                  ไม่สำเร็จ
                </button>
              </div>
            </Col>
          </Row>
          {isLoading ? (
            <FCMLoading />
          ) : (
            <FCMDataTable
              notifications={firebaseCloudMessagingList}
              onSelected={handleNotificationSelected}
              onDeleted={handleDeleteNotification}
            />
          )}
        </Card.Body>
        <Card.Footer>
          <div className="d-flex justify-content-center">
            <div>
              {!isLoading && currentPage !== 1 && (
                // ก่อนหน้า
                <button className="btn btn-primary mr-2" onClick={handleClickPrevPage}>
                  ก่อนหน้า
                </button>
              )}
              <button className="btn btn-primary" disabled>
                {currentPage}
              </button>
              {!isLoading && pagination?.hasNext && (
                // ถัดไป
                <button className="btn btn-primary ml-2" onClick={handleClickNextPage}>
                  ถัดไป
                </button>
              )}
            </div>
          </div>
        </Card.Footer>
      </Card>
    </>
  )
}
